/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utlilites/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  staff: [],

};


const slice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET spell
    getStaffsuccess(state, action) {
      console.log(state.subadmins,"subadmins")
      state.isLoading = false;
      state.staff = action.payload;
    },

  },
});

// Reducer
export const {getStaffsuccess} = slice.actions
export default slice.reducer;


// ----------------------------------------------------------------------

export function getStaff() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      await axiosInstance.get(`all/staff`).then((response) => {
        console.log(response, 'Subadmin--->>>>')
        dispatch(slice.actions.getStaffsuccess(response?.data?.subAdmins));
      })
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------